import {cn} from '@tempmee/core'
import {type HTMLAttributes, forwardRef} from 'react'

export interface TableContainerProps extends HTMLAttributes<HTMLDivElement> {}

/**
 * TableContainer (v3, MUI-aligned) — the overflow wrapper for a `Table`.
 *
 * Mirrors `@mui/material/TableContainer`: a full-width `overflow-x-auto` box so a
 * wide table scrolls horizontally instead of forcing the page wider. The GoTu
 * scrollbar styles apply automatically via the `ds-scroll-area` class this
 * component sets. Set a `maxHeight` via `className`
 * (e.g. `max-h-96 overflow-y-auto`) together with `Table stickyHeader` to pin
 * the header.
 */
export const TableContainer = forwardRef<HTMLDivElement, TableContainerProps>(
  ({className, ...props}, ref) => (
    <div ref={ref} className={cn('ds-scroll-area w-full overflow-x-auto', className)} {...props} />
  ),
)
TableContainer.displayName = 'TableContainer'
